import { render, staticRenderFns } from "./StorageHuoPin.vue?vue&type=template&id=dcd171d4&scoped=true&"
import script from "./StorageHuoPin.vue?vue&type=script&lang=js&"
export * from "./StorageHuoPin.vue?vue&type=script&lang=js&"
import style0 from "./StorageHuoPin.vue?vue&type=style&index=0&id=dcd171d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd171d4",
  null
  
)

export default component.exports